import { AsyncPipe, CurrencyPipe } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, ViewChild, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { EditOrderBase } from '@zero/order/feature-order/base';
import { LoadingIndicatorDirective } from '@zero/shared/ui-directives';
import { DisplayLabelPipe } from '@zero/shared/ui-pipes';
import { UserMessagesComponent } from '@zero/shared/ui-web-components';
import { ButtonComponent, ModalComponent } from '@zero/shared/ui-web-design-system';
import { UserMessagesHolderService } from '@zero/shared/util-web-app-services';

@Component({
  selector: 'order-edit-order',
  templateUrl: './edit-order.component.html',
  styleUrls: ['./edit-order.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LoadingIndicatorDirective,
    UserMessagesComponent,
    AsyncPipe,
    CurrencyPipe,
    TranslocoPipe,
    DisplayLabelPipe,
    ButtonComponent,
    ModalComponent,
  ],
})
export class EditOrderComponent extends EditOrderBase implements AfterViewInit {
  readonly #messageService = inject(UserMessagesHolderService);
  readonly #modal = inject(NgbModal);

  @ViewChild('modal', { static: true }) public modal?: TemplateRef<HTMLElement>;

  readonly #modalConfig: NgbModalOptions = {
    backdrop: 'static',
    modalDialogClass: 'edit-order',
    size: 'md',
    beforeDismiss: () => {
      this.dismiss.emit();
      return true;
    },
  };

  public ngAfterViewInit(): void {
    this.#modal.open(this.modal, this.#modalConfig);
  }

  public close(): void {
    this.dismiss.emit();
    this.closeModal();
  }

  public done(): void {
    this.cancelFinished.emit();
    this.closeModal();
  }

  private closeModal = (): void => {
    this.#messageService.clearAllMessages();
    this.#modal.dismissAll();
  };
}
